import { useDispatch } from "react-redux";
import { ChangeEvent } from "react";
import { Box, InputBase } from "@mui/material";
import { toast } from "react-toastify";

import { setQuantity } from "@/store/appointments/appointmentsSlice";

import { IQuantityInput } from "@/shared/interfaces/service";
import { visitMessage } from "@/utils/constants";

export default function QuantityInput({
    id,
    quantity,
    isEditAppointment,
    isAppointmentComplete,
}: IQuantityInput) {
    const dispatch = useDispatch();

    const changeQuantity = (e: ChangeEvent<HTMLInputElement>) => {
        if (!isAppointmentComplete) {
            const num = Number(e.target.value);
            if (num >= 1 && num <= 50) {
                dispatch(
                    setQuantity({
                        id: id,
                        actualQuantity: num,
                        isEditAppointment: isEditAppointment,
                    }),
                );
            }
        } else toast.error(visitMessage);
    };

    return (
        <Box sx={{ position: "relative", width: 80 }}>
            <Box
                component='label'
                sx={{
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#f6f9f9",
                    px: 0.5,
                    fontSize: "0.75rem",
                    color: "#47586E",
                    zIndex: 1,
                }}
            >
                Кількість
            </Box>

            <Box
                sx={{
                    height: "100%",
                    border: "1px solid #BCC3CD",
                    borderRadius: "4px",
                    padding: "0 8px",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <InputBase
                    type='number'
                    value={quantity}
                    onChange={changeQuantity}
                    inputProps={{ min: 1, max: 50 }}
                    sx={{
                        height: "100%",
                        width: "100%",
                        fontSize: "1rem",
                    }}
                    disabled={isAppointmentComplete}
                />
            </Box>
        </Box>
    );
}
